import { React, useRef, useEffect } from "react";
import { useTestOp } from "./TestOp";
import './test.css'

const InputWidget = ()=> {
  const test = useTestOp();
  const widgetRef = useRef(null);

  useEffect(() => {
    const widget = widgetRef.current;
    let offsetX = 0, offsetY = 0, isDown = false;

    const onMouseDown = (e) => {
      isDown = true;
      offsetX = e.clientX - widget.offsetLeft;
      offsetY = e.clientY - widget.offsetTop;
    };

    const onMouseMove = (e) => {
      if (!isDown) return;
      widget.style.left = `${e.clientX - offsetX}px`;
      widget.style.top = `${e.clientY - offsetY}px`;
    };

    const onMouseUp = () => { isDown = false; };

    widget.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);

    return () => {
      widget.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, []);

  return (
    <div className="testWidgetWindow" ref={widgetRef}>
      <h2>Input Widget</h2>
      <h4>Simulate Inputs</h4>
      <div onClick={test.testMobilityKill}>Mobility Kill</div>
      <div onClick={test.testWeaponKill}>Weapon Kill</div>
      <div onClick={test.testCommsKill}>Comms Kill</div>
      <div onClick={test.testTotalKill}>Total Kill</div>
      <div onClick={test.resetMobilityKill}>Reset Mobility Kill</div>
      <div onClick={test.resetWeaponKill}>Reset Weapon Kill</div>
      <div onClick={test.resetCommsKill}>Reset Comms Kill</div>
      <div onClick={test.resetTotalKill}>Reset Total Kill</div>
    </div>
  );
};

export default InputWidget;